import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const BarChartIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Bar Chart`} {...props}>
    <Path
      d="M3 9.5a.75.75 0 0 1 .75-.75h.5A.75.75 0 0 1 5 9.5v3.75a.75.75 0 0 1-.75.75h-.5A.75.75 0 0 1 3 13.25V9.5ZM7 5.5a.75.75 0 0 1 .75-.75h.5A.75.75 0 0 1 9 5.5v7.75a.75.75 0 0 1-.75.75h-.5A.75.75 0 0 1 7 13.25V5.5ZM11 2.75A.75.75 0 0 1 11.75 2h.5a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75V2.75Z"
      fill="currentColor"
    />
  </Icon>
);
